export const PAGE_MAX_WIDTH = '1156px';
export const CONTENT_MAX_WIDTH = '920px';
export const CONTENT_GUTTER = `max(24px, calc((100% - ${CONTENT_MAX_WIDTH}) / 2))`;

export const ARTICLE_MAX_WIDTH = '680px';
export const CARD_RADIUS = '8px';
export const CARD_PADDING = '24px';

// scTheme has no formInputColor default, so this is what most companies render.
export const DEFAULT_FORM_VALUE_COLOR = '#000000';

// Subtle 1px divider used between list rows and sections.
export const DIVIDER_COLOR = 'rgba(0, 0, 0, 0.05)';

export const MODAL_RADIUS = '16px';

export const SHADOW_ICON_COLOR = 'rgba(0, 0, 0, 0.04)';

export const FANCY_SHADOW =
  '0px 2px 2px 0px rgba(0, 0, 0, 0.08), 0px 4px 4px 0px rgba(0, 0, 0, 0.08), 0px 8px 8px 0px rgba(0, 0, 0, 0.08), 0px 16px 16px 0px rgba(0, 0, 0, 0.08), 0px 32px 32px 0px rgba(0, 0, 0, 0.08)';

export const HEADER_SHADOW = '0px 2px 4px 0px rgba(0, 0, 0, 0.2)';
